import script from "./ContentGenerationView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentGenerationView.vue?vue&type=script&setup=true&lang=js"

import "./ContentGenerationView.vue?vue&type=style&index=0&id=c5171c5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5171c5a"]])

export default __exports__